import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17 * (props.wx ?? 1)}
    height={26 * (props.hx ?? 1)}
    viewBox="0 0 17 26"
    fill="none"
    className={props.className}
  >
    <mask
      id="path-1-outside-1_4826_21622"
      width={18}
      height={26}
      x={0}
      y={0.078}
      fill="#000"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#fff" d="M0 .078h18v26H0z" />
      <path d="M8.505 23.962c-1.285 0-4.628 1.686-6.558-.42-1.548-1.689-.976-5.749.133-8.481.412-1.017.326-2.418.221-3.51C1.8 6.333 1.961 1.608 3.69 1.206 5.078.882 6.186 9.903 8.505 9.903s2.356-8.825 4.134-8.825 2.485 6.096 2.215 10.827c-.062 1.095-.336 2.139.076 3.155 1.109 2.733 1.68 6.792.133 8.481-1.93 2.107-5.273.42-6.559.42z" />
    </mask>
    <path
      fill={props.fill || '#E4E4E7'}
      d="M8.505 23.962c-1.285 0-4.628 1.686-6.558-.42-1.548-1.689-.976-5.749.133-8.481.412-1.017.326-2.418.221-3.51C1.8 6.333 1.961 1.608 3.69 1.206 5.078.882 6.186 9.903 8.505 9.903s2.356-8.825 4.134-8.825 2.485 6.096 2.215 10.827c-.062 1.095-.336 2.139.076 3.155 1.109 2.733 1.68 6.792.133 8.481-1.93 2.107-5.273.42-6.559.42z"
    />
    <path
      d="M8.50529 23.9623C7.22007 23.9623 3.87745 25.648 1.94653 23.5415C0.399318 21.8534 0.970858 17.7931 2.07968 15.0606C2.49239 14.0442 2.40632 12.6432 2.30123 11.5511C1.79913 6.33266 1.9608 1.60832 3.68964 1.20559C5.07805 0.882346 6.18591 9.90305 8.50483 9.90305C10.8237 9.90305 10.8608 1.078 12.6391 1.078C14.4174 1.078 15.1235 7.17432 14.8539 11.9048C14.7916 13.0002 14.5177 14.0437 14.93 15.0601C16.0388 17.7927 16.6103 21.8524 15.0631 23.541C13.1322 25.6475 9.78956 23.9618 8.50434 23.9618L8.50529 23.9623Z"
      stroke={props.stroke || '#A1A1AA'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#path-1-outside-1_4826_21622)"
    />
  </svg>
);
export default SvgNormal;
